import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
	selector: 'app-page404',
	templateUrl: './page404.component.html',
	styleUrls: ['./page404.component.scss']
})
export class Page404Component implements OnInit {
	constructor(private router: Router, private route: ActivatedRoute) { }
	ngOnInit() { }

	role_id: any = '';
	homePage: any = '';
	gotoHomePage() {
		const currentUser = localStorage.getItem('currentUser');
		let parsedUser = JSON.parse(currentUser);
		this.role_id = parsedUser.role_id;
		if (this.role_id == 1) {
			this.homePage = '/mmportal/employee-dashboard';
		} else if (this.role_id == 2) {
			this.homePage = '/mmportal/employee-dashboard';
		} else if (this.role_id == 5) {
			this.homePage = '/mmportal/employee-dashboard';
		} else if (this.role_id == 4) {
			this.homePage = '/mmportal/employee-dashboard';
		} else if (this.role_id == 3) {
			this.homePage = '/mmportal/employee-dashboard';
		} else if (this.role_id == 6) {
			this.homePage = '/admin/dashboard/librarian-dashboard';
		} else if (this.role_id == 7) {
			this.homePage = '/admin/dashboard/support-staff-dashboard';
		} else if (this.role_id == 9) {
			this.homePage = '/admin/dashboard/parent-dashboard';
		} else if (this.role_id == 8) {
			this.homePage = '/admin/dashboard/student-dashboard';
		} else if (this.role_id == 10) {
			this.homePage = '/admin/dashboard/hr-dashboard';
		} else if (this.role_id == 11) {
			this.homePage = '/admin/dashboard/finance-admin-dashboard';
		} else if (this.role_id == 12) {
			this.homePage = '/admin/dashboard/storekeeper-dashboard';
		} else {
			this.homePage = '/authentication/signin';
		}

		this.router.navigate([this.homePage]);
	}
}
